<template>
  <div class="c-ad g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 项目 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 计划 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler :name="item.href" v-for="item in subModules" :key="item.id" :title="item.name">
        <!-- 广告创意素材 -->

        <template v-if="item.href === 'ad_media'">
          <template v-if="formItem.materials_type === 'LIVE_MATERIALS'">
            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">推广身份</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <RadioGroup v-model="formItem.awemeIdentity" type="button">
                  <Radio label="ACCOUNT" disabled>账户信息</Radio>
                  <Radio label="AWEME" disabled>抖音号</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="formItem.awemeIdentity === 'AWEME'">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">抖音号</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <el-select
                  v-model="formItem.native_setting.aweme_id"
                  placeholder="请选择推广抖音号"
                  style="width: 420px; margin-bottom: 10px"
                  :loading="loading"
                  :popper-append-to-body="false"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="item in awemeList"
                    :key="item.aweme_id"
                    :label="item.aweme_name"
                    :value="item.aweme_id"
                    style="width: 420px; height: 60px"
                  >
                    <img :src="item.aweme_avatar" width="40" style="float: left; margin-top: 10px; border-radius: 50px" />
                    <div style="display: flex; flex-direction: column; margin-top: 8px">
                      <span style="float: left; margin-left: 8px; color: black; line-height: 25px">{{ item.aweme_name }}</span>
                      <span style="float: left; margin-left: 8px; color: rgb(126 126 126); line-height: 20px; font-size: 10px"
                        >ID: {{ item.aweme_id }}</span
                      >
                    </div>
                  </el-option>
                </el-select>
                <br />
                <Checkbox v-model="formItem.native_setting.is_feed_and_fav_see" true-value="ON" false-value="OFF"
                  >主页作品列表隐藏视频</Checkbox
                >
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">素材形式</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <RadioGroup v-model="formItem.materials_type" type="button">
                  <Radio disabled label="PROMOTION_MATERIALS">计划素材</Radio>
                  <Radio disabled label="LIVE_MATERIALS">直播素材</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="showFormFields.brand_category">
              <Col span="4" class="col-item">
                <span class="item-field">计划类别</span>
              </Col>
              <Col span="12">
                <el-cascader
                  v-model="formItem.brand_info.yuntu_category_id"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  :options="brandCategory"
                  :props="{ checkStrictly: true, value: 'id', label: 'lable' }"
                  clearable
                ></el-cascader>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="showFormFields.brand_info">
              <Col span="4" class="col-item">
                <span class="item-field">品牌名称</span>
              </Col>
              <Col span="12">
                <el-select v-model="formItem.brand_info.cdp_brand_id" filterable clearable placeholder="请选择" style="width: 100%">
                  <el-option v-for="brand in brandInfo" :key="brand.cdp_brand_id" :label="brand.cdp_brand_name" :value="brand.cdp_brand_id">
                  </el-option>
                </el-select>
              </Col>
            </Row>
          </template>
          <template v-else>
            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">创意素材</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.image_mode" type="button">
                  <Radio label="CREATIVE_IMAGE_MODE_VIDEO"
                    >视频 {{ videoCreative && videoCreative.length ? `(${videoCreative.length})` : '' }}</Radio
                  >
                  <Radio label="CREATIVE_IMAGE_MODE_SMALL" v-if="!isDouyin"
                    >小图 {{ imageCreative && imageCreative.length ? `(${imageCreative.length})` : '' }}</Radio
                  >
                  <Radio label="CREATIVE_IMAGE_MODE_LARGE" v-if="!isDouyin"
                    >大图 {{ largeCreative && largeCreative.length ? `(${largeCreative.length})` : '' }}</Radio
                  >
                </RadioGroup>
              </Col>
            </Row>
            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('video')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="video"
                  :data="videoCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-upload="uploadImage"
                  @on-loading="loadingImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_SMALL'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('image')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="image"
                  :data="imageCreative"
                  :words="wordIds"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-upload="uploadImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_LARGE'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('large')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="large"
                  :data="largeCreative"
                  :words="wordIds"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-upload="uploadImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="showFormFields.text_abstract">
              <Col span="4" class="col-item">
                <span class="item-field">文本摘要</span>
              </Col>
              <Col span="12">
                <el-input
                  v-if="formItem.text_abstract_list.length < 10"
                  v-model="formItem.text_abstract"
                  placeholder="单计划最多10个，长度25-45个字，两个英文字符占1位，空格分隔，回车添加，非必填"
                  @keyup.enter.native="onTextAbstractEnterKeyConfirm"
                >
                  <template slot="append">
                    <el-button @click="onTextAbstractEnterKeyConfirm" type="text">&ensp;添加（回车键）</el-button>
                  </template>
                </el-input>
                <TextItemsPreview v-show="formItem.text_abstract_list.length" :items.sync="formItem.text_abstract_list"></TextItemsPreview>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="showFormFields.keywords">
              <Col span="4" class="col-item">
                <span class="item-field">关键词</span>
              </Col>
              <Col span="12">
                <template v-if="isBlueFlowEnable">
                  <el-select
                    v-model="formItem.blue_flow_keywords"
                    disabled
                    filterable
                    placeholder="请选择蓝海流量关键词"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(keyword, index) in []"
                      :key="index"
                      :label="keyword.blue_flow_keyword_name"
                      :value="keyword.blue_flow_keyword_name"
                    >
                    </el-option>
                  </el-select>
                  <span>蓝海流量关键词创建后不可修改</span>
                </template>

                <template v-else>
                  <el-input style="width: 280px" :value="planSearchTips" readonly placeholder="未添加关键词"></el-input>
                  <el-button type="text" @click="onPlanSearchKeywordAdd">添加关键词</el-button>
                </template>
              </Col>
            </Row>

            <Row v-if="statiAssemble" class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">创意标题</span>
              </Col>
              <Col span="12">
                <div>
                  <Button icon="md-add" @click="addTitleList" :disabled="titleLen === 10">创意标题</Button>
                  <span style="padding: 0 8px">已选：{{ titleLen }}/10</span>
                </div>
              </Col>
            </Row>
            <Row v-if="statiAssemble" class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">&nbsp;</span>
              </Col>
              <Col span="12">
                <m-caption
                  v-for="(item, idx) in formItem.title_list"
                  :key="idx"
                  :index="idx"
                  :max-len="60"
                  v-model="item.title"
                  :words="wordIds"
                  :del="titleLen > 1"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-delete="delTitleList"
                  @on-del-trend="delTrend"
                ></m-caption>
                <span style="color: #ff4400; margin-top: 6px; display: none"
                  >注意：添加了动态词，再清除动态词，一定要使用【清除动态词】按钮，否则系统会报错</span
                >
              </Col>
            </Row>

            <template v-if="showFormFields.selling_points">
              <Row class="row-item" :gutter="12">
                <Col span="4" class="col-item">
                  <span class="item-field row-item-must">应用名</span>
                </Col>
                <Col span="12"><Input v-model="formItem.app_name" placeholder="4-20个字符,中文占两个字符"></Input></Col>
              </Row>
              <Row v-if="formItem.app_type !== 'APP_IOS'" class="row-item" :gutter="12">
                <Col span="4" class="col-item">
                  <Poptip
                    trigger="hover"
                    placement="top-start"
                    width="410"
                    word-wrap
                    content="用户点击广告中“立即下载”按钮以外的区域时所到达的页面"
                  >
                    <Icon type="md-help-circle" size="18" color="#e3e3e3" />
                  </Poptip>
                  <span class="item-field row-item-must">落地页</span>
                </Col>
                <Col span="12">
                  <Input v-model="formItem.web_url" placeholder="建议填写橙子建站链接地址，否则可能创意建立不成功" />
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="4" class="col-item">
                  <span class="item-field row-item-must">产品LOGO</span>
                </Col>
                <Col span="12">
                  <cardptom-icon v-model="formItem.image_ids" :sources="creatives_detail" @on-select="selectLogo" />
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="4" class="col-item">
                  <span class="item-field row-item-must">产品卖点</span>
                </Col>
                <Col span="12" style="margin-left: -3px">
                  <add-tags
                    v-model="formItem.selling_points"
                    :open-id="opId"
                    :is-show-select="false"
                    :max-tag-num="10"
                    :min-len="12"
                    :max-len="18"
                    @on-close="closeTag($event, 'selling_points')"
                  ></add-tags>
                </Col>
              </Row>
            </template>

            <Row class="row-item" :gutter="12" v-if="showFormFields.action_buttons">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">行动号召文案</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <add-tags
                  v-model="formItem.call_to_action_buttons"
                  :open-id="opId"
                  :is-show-select="false"
                  :max-tag-num="10"
                  :min-len="4"
                  :max-len="12"
                  @on-close="closeTag($event, 'call_to_action_buttons')"
                ></add-tags>

                <div style="margin-top: 10px">
                  <el-switch v-model="formItem.intelligent_generation" active-value="ON" inactive-value="OFF"></el-switch>
                  <span class="tips">&ensp;开启智能生成行动号召</span>
                </div>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="showFormFields.brand_category">
              <Col span="4" class="col-item">
                <span class="item-field">计划类别</span>
              </Col>
              <Col span="12">
                <el-cascader
                  v-model="formItem.brand_info.yuntu_category_id"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  :options="brandCategory"
                  :props="{ checkStrictly: true, value: 'id', label: 'lable' }"
                  clearable
                ></el-cascader>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="showFormFields.brand_info">
              <Col span="4" class="col-item">
                <span class="item-field">品牌名称</span>
              </Col>
              <Col span="12">
                <el-select v-model="formItem.brand_info.cdp_brand_id" filterable clearable placeholder="请选择" style="width: 100%">
                  <el-option v-for="brand in brandInfo" :key="brand.cdp_brand_id" :label="brand.cdp_brand_name" :value="brand.cdp_brand_id">
                  </el-option>
                </el-select>
              </Col>
            </Row>

            <Row class="row-item ghost-button-styles" :gutter="12" v-if="showFormFields.dynamic_creative">
              <Col span="4" class="col-item">
                <span class="item-field">动态创意</span>
              </Col>
              <Col span="12">
                <el-radio-group v-model="formItem.dynamic_creative_switch">
                  <el-radio-button ghost label="OFF">不开启</el-radio-button>
                  <el-radio-button ghost label="ON">开启</el-radio-button>
                </el-radio-group>

                <template v-if="formItem.dynamic_creative_switch === 'ON'">
                  <el-checkbox-group v-model="formItem.advanced_dc_settings">
                    <el-checkbox label="OPTIMIZE_SEARCH_RESULTS_PAGE">优化视频、图片、标题等搜索结果页内容</el-checkbox>
                    <el-checkbox label="OPTIMIZE_LANDING_PAGE">优化落地页</el-checkbox>
                  </el-checkbox-group>
                </template>
              </Col>
            </Row>
            <!-- 蓝海流量投放、极速智投必须开启智能拓流，禁止关闭-->
            <!-- <Row class="row-item ghost-button-styles" :gutter="12" v-if="showFormFields.auto_extend_traffic">
            <Col span="4" class="col-item">
              <span class="item-field">智能拓流</span>
            </Col>
            <Col span="12">
              <el-radio-group v-model="formItem.auto_extend_traffic" :disabled="autoExtendTrafficDisabled">
                <el-radio-button ghost label="OFF">不开启</el-radio-button>
                <el-radio-button ghost label="ON">开启</el-radio-button>
              </el-radio-group>
              <p class="tips">启用后利用系统能力自动为您拓展更多相似流量，综合提升计划的跑量能力&转化数</p>
            </Col>
          </Row> -->

            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">推广身份</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <RadioGroup v-model="formItem.awemeIdentity" type="button">
                  <Radio label="ACCOUNT" disabled>账户信息</Radio>
                  <Radio label="AWEME" disabled>抖音号</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="formItem.awemeIdentity === 'AWEME'">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">抖音号</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <el-select
                  v-model="formItem.native_setting.aweme_id"
                  placeholder="请选择推广抖音号"
                  style="width: 420px; margin-bottom: 10px"
                  :loading="loading"
                  :popper-append-to-body="false"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="item in awemeList"
                    :key="item.aweme_id"
                    :label="item.aweme_name"
                    :value="item.aweme_id"
                    style="width: 420px; height: 60px"
                  >
                    <img :src="item.aweme_avatar" width="40" style="float: left; margin-top: 10px; border-radius: 50px" />
                    <div style="display: flex; flex-direction: column; margin-top: 8px">
                      <span style="float: left; margin-left: 8px; color: black; line-height: 25px">{{ item.aweme_name }}</span>
                      <span style="float: left; margin-left: 8px; color: rgb(126 126 126); line-height: 20px; font-size: 10px"
                        >ID: {{ item.aweme_id }}</span
                      >
                    </div>
                  </el-option>
                </el-select>
                <br />
                <Checkbox v-model="formItem.native_setting.is_feed_and_fav_see" true-value="ON" false-value="OFF"
                  >主页作品列表隐藏视频</Checkbox
                >
              </Col>
            </Row>
            <template v-if="showFormFields.anchor_related_type && formItem.awemeIdentity === 'AWEME'">
              <Row class="row-item" :gutter="12">
                <Col span="4" class="col-item">
                  <span class="item-field">原生锚点</span>
                </Col>
                <Col span="12" style="margin-left: -3px">
                  <RadioGroup v-model="formItem.native_setting.anchor_related_type" type="button">
                    <Radio label="OFF">不启用</Radio>
                    <Radio label="AUTO">自动生成</Radio>
                    <Radio label="SELECT">手动生成</Radio>
                  </RadioGroup>
                </Col>
              </Row>
              <Row class="row-item" :gutter="12" v-if="formItem.native_setting.anchor_related_type === 'SELECT'">
                <Col span="4" class="col-item">
                  <span class="item-field row-item-must">选择锚点</span>
                </Col>
                <Col span="12" style="margin-left: -3px">
                  <AnchorSelect
                    v-model="formItem.anchor_id"
                    :anchor-name.sync="formItem.anchorName"
                    :account="Number(accountId)"
                    :package-android="ch_platform_id === 1 ? package_name : null"
                    :package-ios="ch_platform_id === 2 ? package_name : null"
                  ></AnchorSelect>
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="4" class="col-item">
                  <span class="item-field">素材形式</span>
                </Col>
                <Col span="12" style="margin-left: -3px">
                  <RadioGroup v-model="formItem.materials_type" type="button">
                    <Radio disabled label="PROMOTION_MATERIALS">计划素材</Radio>
                    <Radio disabled label="LIVE_MATERIALS">直播素材</Radio>
                  </RadioGroup>
                </Col>
              </Row>
            </template>
          </template>
        </template>

        <!-- 广告预算与出价 -->
        <template v-if="item.href === 'ad_budget'">
          <Row class="row-item" :gutter="12" v-if="!OmBudgetOptimizeSwitch && formItem.budget !== null">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">预算</span>
            </Col>
            <Col span="12">
              <Input
                v-model="formItem.budget"
                @on-blur="inputTrim('budget', formItem.budget, formItem, true)"
                placeholder="预算不少于300元，不超过9999999.99元"
                style="width: 267px"
              >
                <span slot="append">元</span>
              </Input>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.cpa_bid != null">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">出价</span>
            </Col>
            <Col span="12">
              <Input
                v-model="formItem.cpa_bid"
                @on-blur="inputTrim('cpa_bid', formItem.cpa_bid, formItem, true)"
                placeholder="预算不少于0.1元，不超过10000元"
                style="width: 267px"
              >
                <span slot="append">元</span>
              </Input>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.deep_cpabid != null">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">深度目标出价</span>
            </Col>
            <Col span="12">
              <Input
                v-model="formItem.deep_cpabid"
                @on-blur="inputTrim('deep_cpabid', formItem.deep_cpabid, formItem, true)"
                placeholder="请输入0.1~10000的深度优化出价"
                style="width: 320px"
              >
              </Input>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.roi_goal != null">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">ROI系数</span>
            </Col>
            <Col span="12">
              <Input
                v-model="formItem.roi_goal"
                @on-blur="inputTrimFour('roi_goal', formItem.roi_goal, formItem, true)"
                placeholder="请输入ROI系数，ROI系数不大于5，保留小数点后四位"
                style="width: 320px"
              >
              </Input>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">计划名称</span>
            </Col>
            <Col span="12">
              <div class="col-flex" style="height: 32px">
                <span>{{ formItem.promotion_name }}</span>
              </div>
            </Col>
          </Row>
        </template>
      </moduler>
    </div>

    <!-- 广告搜索关键词 -->
    <SearchBidKeywordSelectModal
      v-model="showPlanSearchKeywordModal"
      :account-id="accountId"
      :list="searchPlanKeywordList"
      @confirm="onPlanKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>

    <uploader
      v-model="creativeModel"
      :width="creativeWidth"
      :height="creativeHeight"
      :type="creativeType"
      :smart="creativeSmart"
      :media-id="mediaId"
      :account-id="accountId"
      @on-upload="uploadFileHandler"
      @on-cancel="creativeMult = false"
    ></uploader>

    <div class="c-ad-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="primary" @click.stop="submit" :loading="loading">保存并关闭</Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
import categroyData from '@/data/toutiao/ad_categroy'
import { isArray, isEmpty } from '@/common/js/utils'
import { uploadMedia } from '@/api/common.model'
import { getCreativeWordIds, iesAccountSearch, nativeAnchorGet } from '@/api/toutiao.model'
import { getBrandCategoryInfo } from '@/api/toutiao.local.model'
import { getPromotionInfo, updatePromotion, getProjectInfo } from '@/api/convert.model'
import { getSplitText } from '@/views/create/bytedance/components/plan/usePlanForm.js'
import Creative from '@/components/creative/creative.vue'
import Uploader from './components/uploader.vue'
import MCaption from '@/components/caption.vue'
import AddTags from '@/components/add-tags.vue'
import CardptomIcon from '@/components/cardptom/icon.vue'
import AnchorSelect from '@/components/anchor-select/anchor-select.vue'
import TextItemsPreview from '@/views/create/bytedance/components/layout/text-items-preview.vue'
import SearchBidKeywordSelectModal from '@/views/create/toutiaonew_local/components/group/search-bid.vue'

const defaultIdeaParams = {
  campaign_name: '广告组1',
  title_list: [
    {
      title: '',
      creative_word_ids: []
    }
  ],
  image_list: [],

  blue_flow_keywords: '',
  brand_info: { cdp_brand_id: '', yuntu_category_id: [] },
  text_abstract: '',
  text_abstract_list: [],
  advanced_dc_settings: ['OPTIMIZE_SEARCH_RESULTS_PAGE', 'OPTIMIZE_LANDING_PAGE'],
  dynamic_creative_switch: 'OFF',
  // auto_extend_traffic: 'OFF',

  image_mode: 'CREATIVE_IMAGE_MODE_VIDEO',
  imageCreative: [],
  largeCreative: [],
  groupCreative: [],
  videoCreative: [],

  // 产品信息
  selling_points: [], // 产品卖点
  image_ids: '',

  call_to_action_buttons: [], // 行动号召文案
  awemeIdentity: 'ACCOUNT',
  native_setting: {
    aweme_id: '',
    is_feed_and_fav_see: 'ON'
  },
  anchorName: '',
  // 广告预算与出价
  budget: '', // 预算
  cpa_bid: '', // 出价
  deep_cpabid: '', // 深度目标出价
  roi_goal: '', // ROI系数

  app_name: '',
  creative_display_mode: 'CREATIVE_DISPLAY_MODE_CTR', // 创意展现方式
  creative_material_mode: 'STATIC_ASSEMBLE' // 创意类型
}

export default {
  name: 'ad',
  mixins: [mixin],
  components: { Creative, Uploader, MCaption, AddTags, CardptomIcon, AnchorSelect, TextItemsPreview, SearchBidKeywordSelectModal },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    titleLen() {
      if (this.formItem && this.formItem.title_list) {
        return this.formItem.title_list.length
      } else {
        return 0
      }
    },
    classes() {
      return (item) => {
        return ['m-creative-btn', { 'm-current': item.check }]
      }
    },
    statiAssemble() {
      return this.formItem.creative_material_mode === 'STATIC_ASSEMBLE'
    },
    creativeImageMode() {
      return this.formItem.image_mode
    },

    isSearch() {
      const { ad_type } = this.projectInfo
      return ad_type === 'SEARCH'
    },
    isDuration() {
      return this.isSearch && this.projectInfo.delivery_type === 'DURATION'
    },
    isNormal() {
      return this.isSearch && this.projectInfo.delivery_type === 'NORMAL'
    },
    isBlueFlowEnable() {
      const { blue_flow_package } = this.projectInfo
      return this.isNormal && blue_flow_package?.blue_flow_package_setting === 'ON'
    },
    autoExtendTrafficDisabled() {
      return this.isDuration || this.isBlueFlowEnable
    },
    showFormFields() {
      return {
        // 智能拓流
        auto_extend_traffic: this.isSearch,
        // 动态创意
        dynamic_creative: this.isSearch && !this.isDuration,
        // 品牌名称
        brand_info: !this.isDuration,
        // 广告类别
        brand_category: !this.isDuration,
        // 广告评论
        comment: !this.isDuration,
        // 行动号召
        action_buttons: !this.isDuration,
        // 产品相关信息
        selling_points: !this.isDuration,
        // 原生锚点
        anchor_related_type: !this.isDuration,
        // 文本摘要
        text_abstract: this.isSearch,
        // 关键词
        keywords: this.isSearch
      }
    },
    planSearchTips() {
      const len = this.searchPlanKeywordList?.length
      if (len) {
        const [firstItem] = this.searchPlanKeywordList
        return `已选${firstItem.keyword}...共${len}个关键词`
      }
      return '未添加关键词'
    }
  },
  methods: {
    onPlanSearchKeywordAdd() {
      this.showPlanSearchKeywordModal = true
    },
    onPlanKeywordSelectConfirm(list) {
      this.searchPlanKeywordList = list
      this.formItem.keywords = list.map((item) => ({ word: item.keyword, match_type: item.patern.value }))
    },
    onTextAbstractEnterKeyConfirm() {
      const { text_abstract, text_abstract_list } = this.formItem
      if (!text_abstract.trim()) return
      if (text_abstract_list.length >= 10) return
      const newlist = getSplitText(text_abstract, text_abstract_list)

      this.formItem.text_abstract_list = text_abstract_list.concat(newlist).slice(0, 10)
      this.formItem.text_abstract = ''
    },
    findPathById(tree, targetId) {
      const path = []

      function dfs(nodes, currentPath) {
        for (const node of nodes) {
          const newPath = [...currentPath, node.id]
          if (node.id === targetId) {
            path.push(...newPath)
            return true
          }
          if (node.children && node.children.length > 0) {
            if (dfs(node.children, newPath)) {
              return true
            }
          }
        }
        return false
      }

      dfs(tree, [])
      return path
    },
    getData() {
      getPromotionInfo({
        ad_id: this.adId,
        ad_account_id: this.accountId
      }).then((data) => {
        if (data) {
          const {
            keywords,
            blue_flow_package,
            brand_info,
            promotion_materials,
            creatives_detail,
            budget,
            cpa_bid,
            deep_cpabid,
            roi_goal,
            promotion_name,
            native_setting,
            project_id,
            materials_type
          } = data
          const {
            product_info,
            call_to_action_buttons,
            web_url_material_list,
            video_material_list,
            image_material_list,
            title_material_list,
            anchor_material_list,
            external_url_material_list,
            intelligent_generation,
            text_abstract_list,
            advanced_dc_settings,
            dynamic_creative_switch
          } = promotion_materials || {}
          const { image_ids, selling_points, titles } = product_info || {}
          if (!isArray(creatives_detail)) throw new Error('接口返回的媒体信息为空')
          const image_list = []
          if (isArray(video_material_list) && video_material_list) {
            image_list.push(...video_material_list)
          }
          if (isArray(image_material_list) && image_material_list) {
            image_list.push(...image_material_list)
          }
          // 素材数据处理
          image_list.forEach((ret) => {
            let childs
            const type = this.getType(ret.image_mode)

            if (type === 'video') {
              childs = this.pushVideoIds(creatives_detail, ret.video_id, ret.video_cover_id, ret.image_mode)
            } else {
              const image = this.pushIds(creatives_detail, ret.images).pop()
              ret = Object.assign({}, ret, image)
            }
            ret.children = childs
            ret.creative_word_ids = []
            this[`${type}Creative`].push(ret)
            this.formItem.image_mode = ret.image_mode.includes('VERTICAL') ? ret.image_mode.replace(/_VERTICAL/g, '') : ret.image_mode
          })

          // 标题数据处理
          if (title_material_list?.length) {
            this.formItem.title_list = title_material_list.map((ret) => {
              return {
                title: ret.title,
                creative_word_ids: this.pushWordIds(this.wordIds, ret.word_list, ret.title)
              }
            })
          }

          this.creatives_detail = creatives_detail

          const { yuntu_category_id } = brand_info || {}
          let yuntuPaths = []
          if (yuntu_category_id) {
            // 找到广告类别的全路径
            const paths = this.findPathById(this.brandCategory, String(yuntu_category_id))
            yuntuPaths = paths
          }

          Object.assign(this.formItem, {
            materials_type,
            intelligent_generation,
            call_to_action_buttons,
            brand_info: {
              cdp_brand_id: brand_info?.cdp_brand_id || '',
              yuntu_category_id: brand_info?.yuntu_category_id ? yuntuPaths : []
            },
            app_name: titles ? titles[0] : '',
            image_ids: image_ids ? image_ids[0] : '',
            selling_points,
            app_type: web_url_material_list ? 'APP_ANDROID' : 'APP_IOS',
            web_url: web_url_material_list ? web_url_material_list[0] : '',
            budget,
            cpa_bid,
            deep_cpabid,
            roi_goal,
            promotion_name,
            native_setting,
            awemeIdentity: native_setting?.aweme_id ? 'AWEME' : 'ACCOUNT',
            anchor_id: anchor_material_list ? anchor_material_list[0].anchor_id : '',
            external_url_material_list,
            text_abstract: '',
            text_abstract_list: text_abstract_list?.map((t) => t.abstract_text) || [],
            advanced_dc_settings: advanced_dc_settings || ['OPTIMIZE_SEARCH_RESULTS_PAGE', 'OPTIMIZE_LANDING_PAGE'],
            dynamic_creative_switch: dynamic_creative_switch || 'OFF'
            // auto_extend_traffic: auto_extend_traffic || 'OFF'
          })

          if (blue_flow_package?.blue_flow_package_setting === 'ON') {
            // 蓝海关键词
            const [firstItem] = keywords
            this.formItem.blue_flow_keywords = firstItem.word
          } else {
            if (isArray(keywords)) {
              // 普通关键词
              const paternList = [
                { label: '广泛', value: 'EXTENSIVE' },
                { label: '短语', value: 'PHRASE' },
                { label: '精确', value: 'PRECISION' }
              ]

              this.searchPlanKeywordList = keywords.map((item) => {
                const patern = paternList.find((patern) => patern.value === item.match_type)
                return {
                  keyword: item.word,
                  patern: { ...patern }
                }
              })
            }
          }

          if (project_id) this.getProjectInfo(project_id)
          if (anchor_material_list) this.getAnchorName(anchor_material_list[0].anchor_id)
          this.$Spin.hide()
        }
      })
    },
    getProjectInfo(project_id) {
      getProjectInfo({
        accountId: this.accountId,
        projectId: project_id
      })
        .then((data) => {
          const { plan_info, out_plan_info } = data
          const { ch_platform_id } = plan_info
          const { package_name, delivery_setting } = out_plan_info
          if (delivery_setting.budget_optimize_switch && delivery_setting.budget_optimize_switch === 'ON') {
            this.OmBudgetOptimizeSwitch = true
          }
          this.ch_platform_id = ch_platform_id
          this.package_name = package_name
          this.projectInfo = out_plan_info
        })
        .catch((err) => console.log(err))
    },
    getAnchorName(anchor_id) {
      nativeAnchorGet({
        adAccountId: this.accountId,
        pageIndex: 1,
        pageSize: 10,
        anchor_id: String(anchor_id)
      }).then((data) => {
        this.show = true
        if (data && data.list && isArray(data.list)) {
          if (data.list.length) this.formItem.anchorName = data.list[0].anchor_name
        }
      })
    },
    valid() {
      const rules = [
        // {
        //   name: 'formItem/app_name',
        //   require: true,
        //   min: 4,
        //   max: 20,
        //   desc: '应用名'
        // },
        {
          name: 'formItem/web_url',
          require: true,
          relyon: 'formItem/app_type',
          relyvalue: 'APP_ANDROID',
          min: 4,
          max: 100,
          desc: '落地页'
        },
        {
          name: 'formItem/deep_cpabid',
          min: 0.1,
          max: this.formItem.budget > 10000 ? 10000 : this.formItem.budget,
          desc: '深度目标出价'
        },
        {
          name: 'formItem/roi_goal',
          min: 0.0001,
          max: 5,
          desc: 'ROI系数'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    customValid(creative) {
      const { app_name, image_ids, selling_points, call_to_action_buttons, budget, cpa_bid, title_list, deep_cpabid, roi_goal } =
        this.formItem

      if (this.isDuration) {
      } else {
        if (!app_name) this.errRes.push({ feild: '应用名', msg: '应用名不能为空' })
        if (!image_ids) this.errRes.push({ feild: '产品LOGO', msg: '产品LOGO不能为空' })
        if (!isArray(selling_points) || !selling_points.length) this.errRes.push({ feild: '产品卖点', msg: '产品卖点至少有一个' })
        if (!isArray(call_to_action_buttons) || !call_to_action_buttons.length) {
          this.errRes.push({ feild: '行动号召文案', msg: '行动号召文案至少有一个' })
        }
      }

      // 预算与出价
      if ((isEmpty(budget) || budget < 300 || budget >= 10000000) && !this.OmBudgetOptimizeSwitch && budget != null) {
        this.errRes.push({ feild: '预算', msg: '预算不能为空，且预算范围需在300-9999999.99元之间' })
      }
      if (cpa_bid != null && (isEmpty(cpa_bid) || cpa_bid < 0.1 || cpa_bid > 10000 || cpa_bid > budget)) {
        this.errRes.push({ feild: '出价', msg: '出价不能为空，出价范围需在0.1-10000元之间，且不可大于预算' })
      }
      if (deep_cpabid != null && (isEmpty(deep_cpabid) || deep_cpabid < 0.1 || deep_cpabid > 10000 || cpa_bid > budget)) {
        this.errRes.push({ feild: '深度目标出价', msg: '深度目标出价不能为空，出价范围需在0.1-10000元之间，且不可大于预算' })
      }
      if (roi_goal != null && (isEmpty(roi_goal) || roi_goal < 0.0001 || roi_goal > 5)) {
        this.errRes.push({ feild: 'ROI系数', msg: 'ROI系数不能为空，且系数范围需在0.0001-5之间' })
      }

      // 程序化标题长度
      const titleVaild = title_list.some((ret) => this.lenTitle(ret.title) < 12 || this.lenTitle(ret.title) > 60)
      if (titleVaild) {
        this.errRes.push({ feild: '创意标题', msg: '标题不能少于12或超过60个字符' })
      }

      // 素材判断
      const { video_material_list, image_material_list } = creative
      if (video_material_list.length > 10) this.errRes.push({ feild: '视频素材', msg: '视频素材最多10个' })
      if (image_material_list.length > 10) this.errRes.push({ feild: '图片素材', msg: '图片素材最多10个' })
      if (!video_material_list.length && !image_material_list.length) this.errRes.push({ feild: '创意素材', msg: '请至少选择一个创意素材' })
      if (video_material_list.some((ret) => !ret.image_mode) || image_material_list.some((ret) => !ret.image_mode)) {
        this.errRes.push({ feild: '创意素材', msg: '有一个或多个素材没有上传，不能提交' })
      }
      // 锚点判断
      if (
        this.formItem.native_setting &&
        this.formItem.native_setting.anchor_related_type &&
        this.formItem.native_setting.anchor_related_type === 'SELECT' &&
        !this.formItem.anchor_id
      ) {
        this.errRes.push({ feild: '锚点', msg: '锚点不能为空' })
      }

      if (this.errRes.length) this.formErr = true
    },
    submit() {
      // 广告素材表单验证， 直播素材不需要验证
      let creative = null
      if (this.formItem.materials_type === 'PROMOTION_MATERIALS') {
        this.errRes = this.valid()
        creative = this.mergeCreative(this)
        this.customValid(creative)

        if (this.formErr) return
      }

      const {
        app_type,
        promotion_name,
        web_url,
        image_ids,
        selling_points,
        call_to_action_buttons,
        app_name,
        budget,
        cpa_bid,
        deep_cpabid,
        roi_goal,
        native_setting,
        awemeIdentity,
        anchor_id,
        external_url_material_list,
        intelligent_generation,
        brand_info,
        keywords,
        blue_flow_keywords,
        text_abstract_list,
        advanced_dc_settings,
        dynamic_creative_switch
      } = this.formItem
      native_setting?.aweme_id && delete native_setting.aweme_id

      const params = Object.assign(
        {},
        {
          accountId: this.accountId,
          adId: this.adId,
          promotion_id: this.adId,
          name: promotion_name,
          materials_type: this.formItem.materials_type,
          promotion_materials: Object.assign({}, creative, {
            product_info: {
              titles: [app_name],
              image_ids: [image_ids],
              selling_points
            },
            call_to_action_buttons,
            intelligent_generation,
            anchor_material_list: [
              {
                anchor_type: 'APP_GAME',
                anchor_id
              }
            ],
            external_url_material_list
          }),
          budget,
          // 开启稳定成本投放不支持修改预算
          cpa_bid: cpa_bid,
          deep_cpabid,
          roi_goal,
          native_setting
        }
      )
      if (brand_info) {
        const { yuntu_category_id, cdp_brand_id } = brand_info
        params.brand_info = {}

        if (cdp_brand_id) {
          params.brand_info.cdp_brand_id = cdp_brand_id
        }
        if (yuntu_category_id?.length) {
          params.brand_info.yuntu_category_id = Number(yuntu_category_id.slice(-1))
        }
      }

      if (this.isSearch) {
        if (text_abstract_list?.length) {
          params.promotion_materials.text_abstract_list = text_abstract_list.map((i) => ({ abstract_text: i }))
        }

        if (this.isBlueFlowEnable) {
          // todo
        } else {
          if (this.searchPlanKeywordList?.length) {
            params.keywords = this.searchPlanKeywordList.map((i) => {
              return {
                word: i.keyword,
                match_type: i.patern.value
              }
            })
          }
        }

        // params.auto_extend_traffic = auto_extend_traffic
        //   蓝海流量投放、极速智投必须开启智能拓流，禁止关闭
        // if (this.isDuration || this.isBlueFlowEnable) {
        //   params.auto_extend_traffic = 'ON'
        // }

        // 动态创意
        if (dynamic_creative_switch === 'ON') {
          params.promotion_materials.dynamic_creative_switch = dynamic_creative_switch
          params.promotion_materials.advanced_dc_settings = advanced_dc_settings
        }

        // if (this.isDuration) {
        //   params = {
        //     accountId: params.accountId,
        //     adId: params.adId,
        //     promotion_id: params.promotion_id,
        //     native_setting: params.native_setting,
        //     keywords: params.keywords,
        //     // auto_extend_traffic: params.auto_extend_traffic,
        //     name: params.name,
        //     promotion_materials: {
        //       text_abstract_list: params.promotion_materials.text_abstract_list,
        //       title_material_list: params.promotion_materials.title_material_list,
        //       video_material_list: params.promotion_materials.video_material_list,
        //       image_material_list: params.promotion_materials.image_material_list
        //     }
        //   }
        // }
      }

      if (app_type !== 'APP_IOS') params.promotion_materials.web_url_material_list = [web_url]
      if (awemeIdentity === 'ACCOUNT') delete params.native_setting
      if (params.native_setting?.anchor_related_type !== 'SELECT') delete params.promotion_materials.anchor_material_list

      const liveParams = {
        accountId: params.accountId,
        adId: params.adId,
        brand_info: params.brand_info,
        budget: params.budget,
        cpa_bid: params.cpa_bid,
        deep_cpabid: params.deep_cpabid,
        roi_goal: params.roi_goal,
        name: params.name,
        promotion_id: params.promotion_id,
        materials_type: params.materials_type
      }
      if (params.promotion_materials?.external_url_material_list?.length) {
        // landing_type=APP&&marketing_goal=LIVE&&materials_type=LIVE_MATERIALS时，promotion_materials需传空；
        // landing_type=MICRO_GAME&&marketing_goal=LIVE&&materials_type=LIVE_MATERIALS，promotion_materials支持橙子落地页和字节小程序信息；
        liveParams.promotion_materials = {
          external_url_material_list: params.promotion_materials.external_url_material_list
        }
      }

      this.loading = true
      updatePromotion(this.formItem.materials_type === 'PROMOTION_MATERIALS' ? params : liveParams).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('保存成功,正在关闭页面...')
          setTimeout(() => {
            window.close()
          }, 1500)
        }
      })
    },
    getType(imageMode) {
      let mode
      switch (imageMode) {
        case 'CREATIVE_IMAGE_MODE_LARGE':
          mode = 'large'
          break
        case 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL':
          mode = 'large'
          break
        case 'CREATIVE_IMAGE_MODE_VIDEO':
          mode = 'video'
          break
        case 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL':
          mode = 'video'
          break
        default:
          mode = 'image'
          break
      }
      return mode
    },
    // 查找图片类型
    pushIds(list, ids) {
      const arr = []
      if (!isArray(ids)) throw new Error('图片媒体ID必须是数组')
      ids.forEach((ret) => {
        const image = list.filter((meta) => meta.id === ret || meta.id === ret.image_id)
        image.length && arr.push(...image)
      })
      return arr
    },
    // 查找视频类型
    pushVideoIds(list, video, image, mode) {
      const v = list.filter((meta) => meta.id === video)
      const m = list.filter((meta) => meta.id === image)
      let child = [...v, ...m]
      // 视频组增加模式
      child = child.map((ret) => {
        ret.image_mode = mode
        return ret
      })
      return child
    },
    // 添加动态词
    appendTrend(params) {
      const { type, index, trend, direction } = params
      const meta = type === 'smart' ? this.formItem.title_list : this.formItem[`${type}Creative`]
      const len = meta[index].creative_word_ids.length
      const { title } = meta[index]
      if (len >= 2) {
        if (direction === 'left') {
          meta[index].creative_word_ids.shift()
          meta[index].creative_word_ids.unshift(trend)
        } else if (direction === 'right' || direction === 'plus-right') {
          if (direction === 'plus-right') trend.cut -= 4
          meta[index].creative_word_ids.pop()
          meta[index].creative_word_ids.push(trend)
        }
      } else if (len && direction === 'left') {
        meta[index].creative_word_ids.unshift(trend)
      } else {
        meta[index].creative_word_ids.push(trend)
      }
      meta[index].title = this.reflashTitle(title, meta[index].creative_word_ids, direction)
    },
    // 清除动态词
    deleteTrend(params) {
      const { type, index } = params
      const meta = type === 'smart' ? this.formItem.title_list : this.formItem[`${type}Creative`]
      meta[index].creative_word_ids = []
      meta[index].title = meta[index].title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
    },
    pushWordIds(list, ids, title) {
      const arr = []
      let pos = -1
      if (isArray(ids)) {
        ids.forEach((ret, idx) => {
          const word = list.filter((meta) => meta.creative_word_id === ret)
          if (word.length) {
            pos = title.indexOf('{', pos)
            arr.push(...word)
            if (pos > -1) arr[idx].cut = pos
          }
        })
      }
      return arr
    },
    // 退格删除动态词
    delTrend(params) {
      const { type, index, order } = params
      const meta = type === 'smart' ? this.formItem.title_list : this.formItem[`${type}Creative`]
      // 2动态词 变1时，且是删除了左边动态词
      if (isArray(meta[index].creative_word_ids) && meta[index].creative_word_ids.length > 1 && order === 0) {
        const title = JSON.parse(JSON.stringify(meta[index].title))
        if (meta[index].creative_word_ids.length) {
          meta[index].creative_word_ids[1].cut = title.indexOf(`{${meta[index].creative_word_ids[1].name}}`)
        }
      }
      meta[index].creative_word_ids.splice(order, 1)
      meta[index].title = this.reflashTitle(meta[index].title, meta[index].creative_word_ids)
    },
    // 刷新标题
    reflashTitle(title, words, direction = 'left') {
      let newTitle
      if (words.length >= 2) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const midfix = direction === 'left' ? title.substring(words[0].cut, words[1].cut) : title.substring(words[0].cut, words[1].cut - 4)
        const suffix = direction === 'left' ? title.substring(words[1].cut) : title.substring(words[1].cut - 4)
        newTitle = `${prefix}{${words[0].name}}${midfix}{${words[1].name}}${suffix}`
      } else if (words.length) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const suffix = title.substring(words[0].cut)
        newTitle = `${prefix}{${words[0].name}}${suffix}`
      } else {
        newTitle = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
      }
      return newTitle
    },
    // 选择文案回调
    appendDocument(docs) {
      const len = this.formItem.title_list.length
      if (docs.length > 10 - len) {
        const idx = docs.length - (10 - len)
        docs.splice(-idx, idx)
      }
      docs.forEach((ret) => {
        this.addTitleList(ret)
      })
      this.docModel = false
    },
    mergeCreative(ret) {
      const imageCreative = this.build('image', ret)
      const largeCreative = this.build('large', ret)
      const image_material_list = [...imageCreative, ...largeCreative]
      const video_material_list = this.build('video', ret)
      const title_material_list = this.build('title', ret)
      return { video_material_list, image_material_list, title_material_list }
    },
    build(type, ret) {
      const arr = []
      if (['image', 'large'].includes(type)) {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: ret.image_mode,
            images: [{ image_id: ret.id }]
          })
        })
        return arr
      } else if (type === 'video') {
        ret[`${type}Creative`].forEach((ret) => {
          const [video, cover] = ret.children
          arr.push({
            image_mode: video.image_mode,
            video_id: video.id,
            video_cover_id: cover.id
          })
        })
        return arr
      } else if (type === 'title') {
        ret.formItem.title_list.forEach((met) => {
          arr.push({
            title: met.title,
            word_list: met.creative_word_ids.map((word) => word.creative_word_id)
          })
        })
        return arr
      }
    },
    // 添加素材
    addCreative(type) {
      let item
      const ret = { id: 0, url: '' }
      if (type === 'group') {
        item = {
          title: '',
          creative_word_ids: [],
          children: [JSON.parse(JSON.stringify(ret)), JSON.parse(JSON.stringify(ret)), JSON.parse(JSON.stringify(ret))]
        }
      } else if (type === 'video') {
        item = {
          title: '',
          creative_word_ids: [],
          children: [JSON.parse(JSON.stringify(ret)), JSON.parse(JSON.stringify(ret))]
        }
      } else {
        item = Object.assign({ title: '', creative_word_ids: [] }, ret)
      }
      this[`${type}Creative`].push(item)
    },
    // 选择素材上传入口
    selectImage({ type, index }) {
      if (type === 'group' && isArray(index)) type = 'image'
      if (type === 'video' && isArray(index)) {
        const idx = index[0]
        // 智能封面依赖视频ID
        const videoItem = this[`${type}Creative`][idx].children[0]
        if (videoItem.id || videoItem.video_id) this.creativeSmart = videoItem.id || videoItem.video_id
        type = 'large'
      } else this.creativeSmart = ''
      this.creativeWidth = ''
      this.creativeHeight = ''
      this.creativeMult = false
      this.creativeModel = true
      this.creativeType = type
      // 保存更新位置
      if (type === 'group' || type === 'video') {
        if (typeof index.index !== 'undefined') this.creativeIndex = index.index
      } else this.creativeIndex = index
    },
    // 删除选择框
    deleteItem({ type, index }) {
      this[`${type}Creative`].splice(index, 1)
    },
    uploadImage(params) {
      let imageMode
      const { index, file, type, vertical, idx } = params

      // 上传模式
      switch (type) {
        case 'large':
          if (vertical) imageMode = 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'
          else imageMode = 'CREATIVE_IMAGE_MODE_LARGE'
          break
        case 'video':
          if (vertical) {
            imageMode = idx ? 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
          } else {
            imageMode = idx ? 'CREATIVE_IMAGE_MODE_LARGE' : 'CREATIVE_IMAGE_MODE_VIDEO'
          }
          break
        case 'group':
          imageMode = 'CREATIVE_IMAGE_MODE_GROUP'
          break
        default:
          imageMode = 'CREATIVE_IMAGE_MODE_SMALL'
          break
      }

      this.uploading(true, type, index, idx)
      uploadMedia({
        account: this.accountId,
        id: this.mediaId,
        type: type === 'video' && !idx ? 2 : 1,
        file,
        image_mode: imageMode
      }).then((data) => {
        this.uploading(false, type, index, idx)
        data && this.uploaded(data, type, index, idx, imageMode)
      })
    },
    loadingImage(params) {
      const { index, type, idx } = params
      this.uploading(true, type, index, idx)
    },
    // 本地上传完回调
    uploaded(data, type, index, idx, mode) {
      if (isArray(data)) {
        const pop = data.pop()
        // 视频不知道竖版模式
        if (type === 'video' && pop.height > pop.width) pop.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
        else pop.image_mode = mode
        if (['image', 'large', 'group', 'video'].includes(type)) {
          if (idx !== undefined) {
            this[`${type}Creative`][index].children.splice(idx, 1, pop)
          } else {
            const item = Object.assign(this[`${type}Creative`][index], pop)
            this[`${type}Creative`].splice(index, 1, item)
          }
        }
      }
    },
    // 上传中
    uploading(state, type, index, idx) {
      if (idx === undefined) idx = 0
      if (type === 'large' || type === 'image') {
        this.$set(this[`${type}Creative`][index], 'loading', state)
      } else if (type === 'video' || type === 'group') {
        const newVal = this[`${type}Creative`][index].children[idx]
        const item = Object.assign(newVal, { loading: state })
        this[`${type}Creative`][index].children.splice(idx, 1, item)
      }
    },
    // 选完素材回调
    uploadFileHandler(list) {
      let item
      // 判断服务端错误
      if (isArray(list)) {
        if (this.creativeType === 'image' || this.creativeType === 'large') {
          const pop = list.pop()
          if (isArray(this.creativeIndex)) {
            const [index, idx] = this.creativeIndex
            if (typeof idx === 'number') this.groupCreative[index].children.splice(idx, 1, pop)
            else if (typeof idx === 'string') this.videoCreative[index].children.splice(1, 1, pop)
          } else {
            item = Object.assign(this[`${this.creativeType}Creative`][this.creativeIndex], pop)
            this[`${this.creativeType}Creative`].splice(this.creativeIndex, 1, item)
          }
        } else if (this.creativeType === 'group') {
          item = Object.assign(this[`${this.creativeType}Creative`][this.creativeIndex], { children: list })
          this[`${this.creativeType}Creative`].splice(this.creativeIndex, 1, item)
        } else if (this.creativeType === 'video') {
          const pop = list.pop()
          this.videoCreative[this.creativeIndex].children.splice(0, 1, pop)
        } else if (this.creativeType === 'logo') {
          // 卡片LOGO
          const pop = list.pop()
          if (pop) {
            const { id } = pop
            const idx = list.findIndex((ret) => ret.id === id)
            this.$set(this.formItem, 'image_ids', id)
            if (idx < 0) this.creatives_detail.push(pop)
          }
        }
      } else if (list && list.type === 'video') {
        // 视频组
        const { video, cover } = list

        if (!isArray(video)) {
          this.$Message.error('上传视频时失败')
          this.creativeModel = false
          return
        } else if (!isArray(cover)) {
          this.$Message.error('上传封面时失败')
          this.creativeModel = false
          return
        }
        this.videoCreative[this.creativeIndex].children = [video.pop(), cover.pop()]
      } else console.log('上传素材返回错误')

      // 关闭对话框
      this.creativeModel = false
    },
    // 删除标签
    closeTag(name, data) {
      const index = this.formItem[data].findIndex((ret) => ret === name)
      if (index > -1) this.formItem[data].splice(index, 1)
    },
    // 增加标题
    addTitleList() {
      this.formItem.title_list.push({
        title: '',
        creative_word_ids: []
      })
    },
    // 删除标题
    delTitleList(index) {
      this.formItem.title_list.splice(index, 1)
    },
    selectLogo() {
      this.creativeWidth = 108
      this.creativeHeight = 108
      this.creativeMult = false
      this.creativeModel = true
      this.creativeType = 'logo'
      this.creativeSmart = ''
    }
  },
  data() {
    return {
      loading: false,
      mediaId: 10,
      adId: this.$router.currentRoute.query.id,
      accountId: this.$router.currentRoute.query.acId,
      ch_platform_id: null,
      package_name: '',
      OmBudgetOptimizeSwitch: null,
      deep_bid_type: '', // 上一步深度优化方式
      isDouyin: null, // 版位是否全是仅抖音
      wordIds: [], // 创意词标题
      awemeList: [], // 抖音号列表
      categroyData: categroyData,
      formItem: {},
      // 上传组件
      creativeWidth: '',
      creativeHeight: '',
      creativeMult: false, // 是否多选
      creativeModel: null, // 弹框是否显示
      creativeType: 'video', // 上传类型
      creativeSmart: '', // 智能封面

      creatives_detail: [], // logo 数据源返显

      projectInfo: {},
      showPlanSearchKeywordModal: false,
      searchPlanKeywordList: [],

      brandCategory: [],
      brandInfo: [],

      // 选择文案
      docModel: null,
      plan: {},
      imageCreative: [],
      largeCreative: [],
      groupCreative: [],
      videoCreative: []
    }
  },
  created() {
    this.formItem = defaultIdeaParams
    this.$Spin.show()
    Promise.all([
      getCreativeWordIds({ account: this.accountId }),
      iesAccountSearch({ ad_account_id: this.accountId }),
      getBrandCategoryInfo({ ad_account_id: this.accountId })
    ])
      .then((data) => {
        const [wordData, awemeList, brandCategoryInfo] = data

        const { brand_category_info, brand_info_data } = brandCategoryInfo || {}
        this.brandCategory = brand_category_info || []
        this.brandInfo = brand_info_data || []

        if (wordData && wordData.creative_word) {
          const myWordIds = [1736, 1727, 4, 1737, 5128, 5127]
          this.wordIds = wordData.creative_word.filter((ret) => myWordIds.includes(ret.creative_word_id))
        }
        if (awemeList && isArray(awemeList)) {
          this.awemeList = awemeList
        }

        if (this.editState) this.getData()
        else this.$Spin.hide()
      })
      .catch((e) => {
        console.log(e)
        this.$Message.error('请求接口错误')
      })
  }
}
</script>

<style lang="scss" scoped>
.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}

.item-field {
  height: 32px;
  line-height: 32px;
}

.row-item-control {
  margin-top: 12px;
}

.row-item-label {
  text-align: right;
  padding: 8px;
}

.m-creat-box {
  min-height: 165px;
}

.c-ad {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .c-ad-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

::v-deep.col-flex {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.ivu-affix .c-idea-bar {
  border-bottom: 1px solid #e8eaec;
}

::v-deep .ivu-btn {
  margin-right: 8px;
}
</style>
